<template>
    <div class="navWrap">
        <div class="row" v-if="this.windowWidth > 819">
            <nav class="navtopInner col-12">
                <router-link v-for="(route, index) in theRoutes" :key="index" :to="{ name: route.name }">{{
                    route && route.components && route.components.default && route.components.default.display ?
                        route.components.default.display : route.meta.display }}<!-- span
                v-if="index < this.theRoutes.length-1" &nbsp;|&nbsp;--></router-link>
            </nav>
        </div>
        <div class="row" v-else>
            <div
                class="mobileHamburgerRow"
                role="button"
                tabindex="0"
                data-bs-target="#collapseTarget"
                data-bs-toggle="collapse"
                aria-label="Open menu"
            >
                <div class="material-icons-menu material-icons">menu</div>
            </div>
            <div class="collapse py-2" id="collapseTarget">
                <nav class="navtopCompressed">
                    <div class="mobileMenuHeader">
                        <button class="mobileMenuClose" type="button" @click="closeMobileMenu" aria-label="Close menu">
                            ✕
                        </button>
                    </div>
                    <router-link v-for="(route, index) in theRoutes" :key="index" :to="{ name: route.name }" @click="closeMobileMenu">{{
                        route && route.components && route.components.default && route.components.default.display ?
                            route.components.default.display : route.meta.display }}<!-- span
                v-if="index < this.theRoutes.length-1" &nbsp;|&nbsp;--></router-link>
                </nav>
            </div>

        </div>
    </div>
</template>

<script>
import router from "../router"
import { isAuthenticated, onAuthChanged } from "@/libs/auth";
import Collapse from "bootstrap/js/dist/collapse";

//let theRoutes = router.getRoutes();
//theRoutes = theRoutes.filter((route) => route && route.meta && (!route.meta.hideNavbar || (route.meta.authRequired && cookies.get("theAuthCookie"))));

function buildRoutes() {
    let routes = router.getRoutes().filter((route) => {
        const meta = route?.meta || {};
        const authenticated = isAuthenticated();
        const authRequired = meta.authRequired == true;
        const guestOnly = meta.guestOnly == true;
        const isAuthorized = !authRequired || authenticated;
        const isGuestAllowed = !guestOnly || !authenticated;
        const willShow = !meta.hideNavbar;
        const showing = isAuthorized && isGuestAllowed && willShow;
        //console.log(` route name: ${route.name},\n authRequired: ${authRequired},\n authorized: ${authorized},\n isAuthorized: ${isAuthorized}, willShow: ${willShow},\n showing: ${showing}`)

        return showing;
    })
    return routes
}

export default {
    data() {
        return {
            theRoutes: buildRoutes(),
            isMenuOpen: false,
            windowWidth: window.innerWidth,
            mobileCollapse: null,
            removeAuthChangedListener: null,
        }
    },
    watch: {
        "$route.fullPath"() {
            this.closeMobileMenu()
        }
    },
    methods: {
        getMobileCollapse() {
            const el = document.getElementById("collapseTarget");
            if (!el) return null;
            this.mobileCollapse = Collapse.getOrCreateInstance(el, { toggle: false });
            return this.mobileCollapse;
        },
        closeMobileMenu() {
            const collapse = this.getMobileCollapse();
            if (!collapse) return;
            collapse.hide();
            this.isMenuOpen = false;
        },
        redirect() {
            this.$router.push({ name: "Home" })
        },
        back() {
            this.$router.go(-1)
        },
        forward() {
            this.$router.go(1)
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        refreshRoutes() {
            this.theRoutes = buildRoutes();
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
            console.log(`toggleMenu ${this.isMenuOpen} `)
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.removeAuthChangedListener = onAuthChanged(() => this.refreshRoutes());
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.removeAuthChangedListener) this.removeAuthChangedListener();
    },
}

</script>

<style>
.navWrap {
    padding-top: 0;
}
.mobileHamburgerRow {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
}
.navtopOuter {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-weight: 700;
    padding: 30px;
}

.navtopInner {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-weight: 600;
    background: var(--qrce-surface);
    border: 1px solid var(--qrce-border);
    border-radius: 16px;
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.10);
    padding: 8px 10px;
}


.navtopInner a {
    font-weight: 600;
    color: var(--qrce-muted);
    text-decoration: none;
    padding: 8px 12px;
    border-radius: 999px;
    font-size: 1.43em;
    text-align: left;
    transition: background-color 120ms ease, color 120ms ease;
}

.navtopInner a.router-link-exact-active {
    color: var(--qrce-surface);
    background: var(--qrce-primary);

}

.navtopInner a:hover {
    background: rgba(29, 78, 216, 0.08);
    color: var(--qrce-text);
}

.navtopCompressed {
    display: grid;
    justify-content: space-between;
    align-items: center;

    width: 40%;
    background: var(--qrce-surface);
    border-left: 1px solid var(--qrce-border);
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    box-shadow: 0 18px 34px rgba(15, 23, 42, 0.18);
    padding: 5px;

    float: right;
    position: fixed;
    z-index: 1;
    top: 0px;
    left: 60%;
    height: 95%;
    overflow: auto;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 1.56em;
    text-align: left;
}

.mobileMenuHeader {
    display: flex;
    justify-content: flex-end;
    padding: 6px 6px 0;
}

.mobileMenuClose {
    appearance: none;
    background: transparent;
    border: 1px solid var(--qrce-border);
    border-radius: 12px;
    width: 42px;
    height: 42px;
    line-height: 1;
    font-size: 26px;
    color: var(--qrce-muted);
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);
    margin: 0;
    padding: 0;
}

.mobileMenuClose:hover {
    color: var(--qrce-text);
    background: rgba(29, 78, 216, 0.06);
}

.navtopCompressed a {
    font-weight: 600;
    color: var(--qrce-muted);
    text-decoration: none;
    padding: 10px;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.navtopCompressed a.router-link-exact-active {
    color: var(--qrce-surface);
    background: var(--qrce-primary);
}

.navtopCompressed a:hover {
    background: rgba(29, 78, 216, 0.08);
    color: var(--qrce-text);
}

button {
    margin: 0 10px;
    padding: 10px;
    border: none;
    border-radius: 4px;
}

/* material icons setup */
.material-icons-menu {
    font-size: 62px;
    margin-left: 10px;
    color: var(--qrce-muted);
    cursor: pointer;
}

.material-icons-menu:hover {
    color: rgba(71, 85, 105, 0.75);
}
</style>
